import { render, staticRenderFns } from "./error-overlay.vue?vue&type=template&id=4a503318&scoped=true&"
import script from "./error-overlay.vue?vue&type=script&lang=js&"
export * from "./error-overlay.vue?vue&type=script&lang=js&"
import style0 from "./error-overlay.vue?vue&type=style&index=0&id=4a503318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a503318",
  null
  
)

export default component.exports